import { Grid } from "@material-ui/core"
import { PedidoModel } from "api/cardapio/models/pedido/pedido"
import { CardPedidoPendente } from "components/cards/card-pedido-pendente/card-pedido-pendente"
import React from "react"

export type TPedidosPendentesListDataProps = {
    list: PedidoModel[]
    onClick: (pedidoId: string) => void
}

export const PedidosPendentesListData = ({ list, onClick }: TPedidosPendentesListDataProps) => {
    return (
        <>
            {list.map((pedido) => (
                <Grid item xs={12} key={pedido.id}>
                    <CardPedidoPendente
                        pedido={pedido}
                        onClick={onClick}
                    />
                </Grid>
            ))}
        </>
    )
}